import { Box, Skeleton } from '@mui/material'

import { styles } from './modal-check-in-skeleton.styles'

const TAB_WIDTHS = [72, 96, 64]
const ROW_COUNT = 4

const ModalCheckInSkeleton = () => (
  <Box sx={styles.root} data-testid="modal-check-in-skeleton">
    <Box sx={styles.tabs}>
      {TAB_WIDTHS.map((width) => (
        <Skeleton key={width} animation="wave" variant="rounded" width={width} height={28} />
      ))}
    </Box>
    <Skeleton animation="wave" variant="rounded" height={44} />
    {Array.from({ length: ROW_COUNT }, (_, index) => (
      <Box key={index} sx={styles.row}>
        <Skeleton animation="wave" variant="circular" width={40} height={40} />
        <Box sx={styles.text}>
          <Skeleton animation="wave" variant="rounded" width="45%" height={14} />
          <Skeleton animation="wave" variant="rounded" width="30%" height={12} />
        </Box>
      </Box>
    ))}
  </Box>
)

export default ModalCheckInSkeleton
